import { render, staticRenderFns } from "./DhmeImportObjectElements.vue?vue&type=template&id=500bd9bd&scoped=true"
import script from "./DhmeImportObjectElements.vue?vue&type=script&lang=js"
export * from "./DhmeImportObjectElements.vue?vue&type=script&lang=js"
import style0 from "./DhmeImportObjectElements.vue?vue&type=style&index=0&id=500bd9bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500bd9bd",
  null
  
)

export default component.exports